import React, { useState, useRef, useEffect, useCallback, memo } from 'react';
import { bool } from 'prop-types';

import classnames from 'classnames';
import Snackbar from '@andes/snackbar';

import FullSnackbar from '../full-shipping-snackbar/full-snackbar';
import useIntersectionObserver from '../../../hooks/use-intersection-observer';
import { markWithCookie, isCookieMarked } from '../../../lib/cookies';
import { COOKIE_NAME } from '../constants';

const namespace = 'ui-search-fullpopup';

/**
 * Component FullTopEmpty
 * @param {Object} props - Props del componente
 * @param {boolean} [props.disabledByCookie] - Indica si el componente está deshabilitado por cookie
 * @returns {JSX.Element} Componente de snackbar con información de envío para la parte superior en desktop
 */

const FullTopEmpty = memo(({ disabledByCookie }) => {
  const initialState = !disabledByCookie && !isCookieMarked(COOKIE_NAME);

  const refCruce = useRef();
  const headerRef = useRef();

  const [isOnScreen] = useIntersectionObserver(refCruce, { threshold: 0.2 }, 0.1, true);
  const [visible, setVisible] = useState(initialState);

  const handleHeaderStyle = useCallback((shouldSetStyle) => {
    if (headerRef.current?.style) {
      headerRef.current.style.zIndex = shouldSetStyle ? '10' : '';
    }
  }, []);

  useEffect(() => {
    headerRef.current = document.querySelector('.nav-header');

    if (visible) {
      handleHeaderStyle(true);
    }

    return () => handleHeaderStyle(false);
  }, [visible, handleHeaderStyle]);

  const disableBottom = useCallback(() => {
    setVisible(false);
    handleHeaderStyle(false);
    markWithCookie(COOKIE_NAME, 86400);
  }, [handleHeaderStyle]);

  const containerClassName = classnames({
    'ui-search-fullpopup-up-float': isOnScreen,
    'ui-search-fullpopup-up-sticky': !isOnScreen,
    'ui-search-fullpopup-up-float-closeable': isOnScreen,
  });

  const snackbarClassName = classnames(namespace, `${namespace}-up`, {
    [`${namespace}-up--animate-show`]: visible,
    [`${namespace}-up--animate-hide`]: !visible,
  });

  return (
    <div ref={refCruce}>
      <div className={containerClassName}>
        <Snackbar show={visible} className={snackbarClassName}>
          <FullSnackbar closeAction={disableBottom} />
        </Snackbar>
      </div>
    </div>
  );
});

FullTopEmpty.displayName = 'FullTopEmpty';

FullTopEmpty.propTypes = {
  disabledByCookie: bool,
};

export default FullTopEmpty;
